// extracted by mini-css-extract-plugin
export default {"resultScene":"Z1M6FC","toast":"G3zGMu","img":"DpDvho","frame":"EctGQO","title":"h5M4IZ","titleCn":"KIAaG0","titleEn":"nDG0yD","nextButton":"l2Fbl6","active":"qUixJV"};